export default __webpack_public_path__ + "static/media/real_estate_web-md@2x.36606f8c.webp";